// Configuration object for search events
export const searchEventsConfig = {
    events: {
        searchModal: {
            parentSelector: '.header',
            selector: '.header__icon--search',
            events: {
                open: {
                    selector: 'svg.modal__toggle-open.icon.icon-search',
                    event: 'search',
                    component: 'search_modal',
                    element: 'modal',
                    action: 'open',
                    trigger: 'click'
                },
                close: {
                    selector: '.search-modal__close-button',
                    event: 'search',
                    component: 'search_modal',
                    element: 'modal',
                    action: 'close',
                    trigger: 'click'
                }
            }
        },
        searchField: {
            parentSelector: '.header',
            selector: '.search__input',
            events: {
                focus: {
                    event: 'search',
                    component: 'header',
                    element: 'text_field',
                    action: 'focus',
                    trigger: 'focus'
                },
                input: {
                    event: 'search',
                    component: 'header',
                    element: 'text_field',
                    action: 'input',
                    trigger: 'input',
                    getDynamicData: (element) => ({
                        action_value: element.value
                    })
                },
                submit: {
                    event: 'search',
                    component: 'header',
                    element: 'text_field',
                    action: 'submit',
                    trigger: 'submit',
                    getDynamicData: (element) => ({
                        action_value: element.value,
                        link_url: `/search?q=${encodeURIComponent(element.value)}`
                    })
                }
            }
        },
        searchFieldClear: {
            parentSelector: '.header',
            selector: '.header__search .reset__button svg.icon.icon-close',
            event: {
                event: 'search',
                component: 'search_bar',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: () => ({
                    action_value: 'remove'
                })
            }
        },
        searchBar: {
            parentSelector: '.template-search',
            selector: '.template-search__search .search__input',
            events: {
                click: {
                    event: 'search',
                    component: 'search_bar',
                    element: 'text_field',
                    action: 'click',
                    trigger: 'click'
                },
                input: {
                    event: 'search',
                    component: 'search_bar',
                    element: 'text_field',
                    action: 'input',
                    trigger: 'input',
                    getDynamicData: (element) => ({
                        action_value: element.value
                    })
                },
                submit: {
                    event: 'BRUUHHH',
                    component: 'search_bar',
                    element: 'text_field',
                    action: 'submit',
                    trigger: 'submit',
                    getDynamicData: (element) => ({
                        action_value: element.value,
                        link_url: `/search?q=${encodeURIComponent(element.value)}`
                    })
                }
            }
        },
        searchBarClear: {
            parentSelector: '.template-search__search',
            selector: '.reset__button svg.icon.icon-close',
            event: {
                event: 'search',
                component: 'search_bar',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: () => ({
                    action_value: 'remove'
                })
            }
        },
        searchBarIconClick: {
            parentSelector: '.template-search__search',
            selector: 'button.search__button svg.icon.icon-search',
            event: {
                event: 'search',
                component: 'search_bar',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const inputElement = element.closest('.search')?.querySelector('.search__input');
                    const searchTerm = inputElement ? inputElement.value : '';
                    return {
                        action_value: searchTerm,
                        link_url: `/search?q=${encodeURIComponent(searchTerm)}`
                    };
                }
            }
        },
        searchIconClick: {
            parentSelector: '.header .header__search',
            selector: 'button.search__button svg.icon.icon-search',
            event: {
                event: 'search',
                component: 'header',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const inputElement = element.closest('.search-modal__form, .header__search')?.querySelector('.search__input');
                    const searchTerm = inputElement ? inputElement.value : '';
                    return {
                        action_value: searchTerm,
                        link_url: `/search?q=${encodeURIComponent(searchTerm)}`
                    };
                }
            }
        },
        headerSearchResultsClick: {
            parentSelector: '.predictive-search',
            selector: 'a.predictive-search__item, a.predictive-search__item *',
            event: {
                event: 'search',
                component: 'header',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const anchorElement = element.closest('a.predictive-search__item');
                    if (!anchorElement) return null;
                    
                    let fieldName = 'link';
                    const parentList = anchorElement.closest('ul.predictive-search__results-list');
                    
                    if (parentList && parentList.id) {
                        if (parentList.id.includes('-queries-list')) {
                            if (anchorElement.href.includes('/collections/')) {
                                fieldName = 'collections';
                            } else {
                                fieldName = 'suggestions';
                            }
                        } else if (parentList.id.includes('-products-list')) {
                            fieldName = 'products';
                        } else if (parentList.id.includes('-pages-list')) {
                            fieldName = 'pages';
                        }
                    }
                    
                    const contentElement = anchorElement.querySelector('.predictive-search__item-heading');
                    const linkText = contentElement ? contentElement.textContent.trim() : anchorElement.textContent.trim();

                    return {
                        field_name: fieldName,
                        link_text: linkText,
                        link_url: anchorElement.href
                    };
                }
            }
        },
    }
}; 